module.exports = __webpack_public_path__ + "static/media/journey.2dc0f5ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/journey.svg
// module id = 107
// module chunks = 0